import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { EditoralCtaBlockFragment } from '../types/graphqlTypes';
import { ButtonRenderer } from './buttonRenderer/ButtonRenderer';
import HtmlContent from './Html';
import { ImageCardRenderer } from './ImageCardRenderer';
import { LinkList } from './LinkList';
import { Section } from './Section';
import { Spacer } from './Spacer';
import { Typography } from './Typography';

interface StyledEditorialBlockProps {
  center: boolean;
}

export const StyledEditorialBlock = styled.div<StyledEditorialBlockProps>`
  ${({ theme: { space, media }, center }) => css`
    display: flex;
    flex-direction: column;
    gap: ${space.lg};

    @media (min-width: ${media.lg}) {
      display: flex;
      flex-direction: row;
      align-items: ${center ? 'center' : 'flex-start'};

      > * {
        flex-basis: 50%;
      }
    }
  `};
`;

export const StyledCopy = styled(Spacer)`
  ${({ theme: { space, media } }) => css`
    @media (min-width: ${media.lg}) {
      padding: 0 ${space.lg};
    }
  `};
`;

export const EditoralCTABlock: FC<Omit<EditoralCtaBlockFragment, '__typename'>> = ({
  title,
  lead,
  html,
  linkLists,
  button,
  imageCards,
  alignment,
}) => (
  <Section contained>
    <StyledEditorialBlock center={alignment === 'Centre'}>
      {/* Left column */}
      <StyledCopy>
        {/* Title */}
        {title && (
          <Typography component="h2" variant="displaySmall">
            {title}
          </Typography>
        )}

        {/* Lead */}
        {lead && (
          <Typography component="p" variant="lead">
            {lead}
          </Typography>
        )}

        {/* Html */}
        {html && <HtmlContent>{html}</HtmlContent>}

        {/* Link lists */}
        {linkLists && linkLists.length > 0 ? (
          <>
            {linkLists.map((linkList, index) => (
              <LinkList {...linkList} key={`ll-${index}`} />
            ))}
          </>
        ) : (
          ''
        )}

        {/* Button */}
        {button && <ButtonRenderer button={button} />}
      </StyledCopy>
      {/* Right column */}
      <Spacer>
        {/* Image Card CTAs */}

        {imageCards && imageCards.length > 0 ? (
          <>
            {imageCards.map((imageCard, index) => (
              <ImageCardRenderer {...imageCard} key={`ic-${index}`} />
            ))}
          </>
        ) : (
          ''
        )}
      </Spacer>
    </StyledEditorialBlock>
  </Section>
);
